import { render, staticRenderFns } from "./BrebBtn.vue?vue&type=template&id=652050de&scoped=true&"
import script from "./BrebBtn.vue?vue&type=script&lang=js&"
export * from "./BrebBtn.vue?vue&type=script&lang=js&"
import style0 from "./BrebBtn.vue?vue&type=style&index=0&id=652050de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652050de",
  null
  
)

export default component.exports